/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".finapp-iframe[_ngcontent-%COMP%]{display:block;width:100%;margin:0 auto;border:none;min-height:400px}.finapp-budget-iframe[_ngcontent-%COMP%]{display:block;width:100%;height:720px;margin:0 auto;border:none;min-height:400px}.hidden-form[_ngcontent-%COMP%]{position:absolute;z-index:-1}.iframe-parent-wrapper[_ngcontent-%COMP%]{overflow-y:scroll}.yodlee-consent-content[_ngcontent-%COMP%]{max-height:500px;overflow-y:scroll}.yodlee-consent-ctas[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:-15px}"];
export { styles as styles };
